import React from 'react';
import Autocomplete from 'react-autocomplete';
import { emailDomains } from '../../utils/emailDomains';

export const EmailInput = (props) => (
	<label 
		className={props.labelClass} 
		htmlFor={props.name}>
		<span className="label">
            {props.label}
            {props.required ? ('*') : (false)}
        </span>
		<Autocomplete 
			wrapperStyle={{
				position: 'relative'
			}}
			value={props.value}
			inputProps={{
				id: props.id,
				type: "text",
				name: props.name,
				className: props.className,
				placeholder: props.placeholder,
				maxLength: props.maxLength
			}}
			items={emailDomains}
			getItemValue={(item) => item}
			onChange={(event, value) => {props.onChange(event)}}
			onSelect={(item) => props.handleEmailAutocomplete(props.name, item)}
			shouldItemRender={(item, value) => {
				let suffix;
				const suffixStart = value.indexOf('@');
				if(suffixStart != -1) {
					suffix = value.slice(suffixStart + 1);
					return item.toLowerCase().indexOf(suffix.toLowerCase()) !== -1
				}				
			}}
			renderMenu={children => (
	            <div className="autocomplete-menu">
	              {children}
	            </div>
	        )}
			renderItem={(item, isHighlighted) => (
				<div
					className={`autocomplete-option ${isHighlighted ? 'autocomplete-highlighted' : ''}`}
					key={item}
				>{item}</div>
			)}
			autoHighlight={true}
		/>
		<span className="form-error">
    		<p>{props.errMessage}</p>
    	</span>
	</label>
);


// WEBPACK FOOTER //
// ./src/components/BasicForm/EmailInput.js